<template>
  <container :class="['my-4', 'test-toolbar', 'hidden', 'lg:block']">
    <toolbar :color="$dark ? 'white' : 'black'" :color-lightness="null" :dense="dense" :bg-color="$dark ? 'black' : 'white'" :bg-color-lightness="null">
      <toolbar-icon v-if="icon">
        <icon :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" :name="icon" :provider="iconProvider" />
      </toolbar-icon>
      <toolbar-title :text="title" v-if="title" />
      <toolbar-actions width="90%">
        <slot /><btn :uppercase="false" :class="['ml-1']" v-if="codeBtn" :disabled="!showCodeBtn" @click="showCodeViewer" size="xs" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.code" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.code }}</btn><!--
        --><btn :uppercase="false" v-if="docsBtn" :disabled="!showDocsBtn" @click="scrollToElement('.bcq-api-explorer')" size="xs" color="white" :class="['ml-2']" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.docs" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.docs }}</btn>
      </toolbar-actions>
    </toolbar>
    <div v-html="$lang.testToolbarInfo" :class="['text-right', 'italic', 'text-xs', 'my-3']" />
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'TestToolbar',
  mixins: [
    methods
  ],
  data () {
    return {
      codeViewer: {
        visible: true
      },
      showDocsBtn: false,
      showCodeBtn: false
    }
  },
  props: {
    dense: {
      type: Boolean,
      default: true
    },
    docsBtn: {
      type: Boolean,
      default: true
    },
    codeBtn: {
      type: Boolean,
      default: true
    },
    actionsWidth: {
      type: String,
      default: '90%'
    },
    icon: {
      type: String
    },
    iconProvider: {
      type: String,
      default: 'mdi'
    },
    title: {
      type: String
    }
  },
  created () {
    this.bind()
  },
  mounted () {
    this.probeForCodeSamples()
  },
  methods: {
    bind () {
      this.$root.$on('documentation', (documentation) => {
        if (documentation) {
          this.showDocsBtn = true
        } else {
          const excludes = this.$root.config.documentationExclusionPages
          const slug = this.$route.path.split('/').pop()
          if (!excludes.includes(slug)) {
            this.log('warning', ':', this.$lang.documentationNotAddedYet.toLowerCase(), null, 'warn')
          }
        }
      })
    },
    probeForCodeSamples () {
      const slug = this.getSlug()
      this.$http({
        url: `${slug}/data.json`
      }).then(data => {
        if (data && typeof data.data === 'object') {
          this.showCodeBtn = true
        }
      }).catch(error => {
        this.log('error', ':', error, null, 'error')
        this.log('warning', ':', this.$lang.codeSamplesNotAddedYet.toLowerCase(), null, 'warn')
      })
    },
    getSlug () {
      return `${this.$config.codeMeta}${this.$route.path.split('/').pop()}`
    },
    showCodeViewer () {
      const codeViewer = this.$root.codeViewer
      const slug = this.getSlug()
      this.$http({
        url: `${slug}/script.txt`
      }).then(script => {
        codeViewer.script = script.data
        this.$http({
          url: `${slug}/template.html`
        }).then(html => {
          codeViewer.template = html.data
          this.$http({
            url: `${slug}/data.json`
          }).then(json => {
            codeViewer.data = json.data
            this.$nextTick(() => {
              codeViewer.visible = true
            })
          }).catch(error => {
            console.log(error)
          })
        })
      }).catch(error => {
        alert(this.$lang.codeSamplesNotAdded)
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/test-toolbar.vue